import React from "react";
import {OverlayView} from "@react-google-maps/api";
import {Spring, animated} from 'react-spring/renderprops'
import styles from "./style.module.css";


const getPixelPositionOffset = (width, height) => ({
  x: -(width / 2),
  y: -(height / 2),
});

const CircleItem = React.memo((props)=>{
  const [reset, setReset] = React.useState(false);
  const [useDelay, setUseDelay] = React.useState(true);
  const [color, setColor] = React.useState('transparent');
  const onStart = React.useMemo(()=>()=> {
    setTimeout(()=>{
      setColor('#2E4BB5');
    },props.delay);
    setReset(false);
  },[setReset,setColor, props.delay]);
  const onRest = React.useMemo(()=>()=> {
    setUseDelay(false);
    setReset(true);
  },[setReset,setUseDelay]);

  return (
    <Spring
      reset={reset}
      from={{opacity: 1, scale: 0.2, strokewidth: 10}}
      to={{opacity: 0, scale: 1, strokewidth: 50}}
      config={{
        duration: 4000,
      }}
      onStart={onStart}
      onRest={onRest}
      delay={useDelay? props.delay : 0}
    >
      {({ opacity, scale, strokewidth }) =>
        <animated.circle
          cx="250"
          cy="250"
          r="200"
          style={{
            fill: 'none',
            margin: 'auto',
            stroke: color,
            strokeWidth: `${strokewidth}px`,
            opacity: opacity,
            transform: `scale(${scale})`,
            transformOrigin: 'center',
          }}
        />
      }
    </Spring>
  )

});

export default React.memo(({lat, lng}) => {

  return (
    <OverlayView
      position={{
        lat,
        lng,
      }}
      mapPaneName={OverlayView?.OVERLAY_MOUSE_TARGET}
      getPixelPositionOffset={getPixelPositionOffset}
    >
      <div className={styles.pulse}>
        <svg
          height="500" width="500"
        >
          {[1, 2, 3, 4].map((x, i) =>
            <CircleItem
              key={x}
              delay={i * 1000}
            >
            </CircleItem>)
          }
        </svg>
      </div>
    </OverlayView>
  );
});

